import { render, staticRenderFns } from "./confirm-single-document-dialog.vue?vue&type=template&id=5dee901b&scoped=true"
import script from "./confirm-single-document-dialog.vue?vue&type=script&lang=js"
export * from "./confirm-single-document-dialog.vue?vue&type=script&lang=js"
import style0 from "./confirm-single-document-dialog.vue?vue&type=style&index=0&id=5dee901b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dee901b",
  null
  
)

export default component.exports